import { getExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { bypassHtmlCacheRegex } from '@ms/yammer-web-support/dist/pwa/routes';
import type { SWSyncMessageType } from '@ms/yammer-web-support/dist/pwa/serviceWorkerSync';
import type { YammerTeamsNativeState } from 'state/types';

const syncDelayMs = 5000;
let pendingSyncTimeout: ReturnType<typeof setTimeout> | undefined;

export const cancelPendingCacheSync = () => {
  if (pendingSyncTimeout) {
    clearTimeout(pendingSyncTimeout);
    pendingSyncTimeout = undefined;
  }
};

export const triggerCacheSync = (getState: (() => YammerTeamsNativeState) | null) => {
  const isEnabled = getState != null && getExperimentTreatment(getState(), 'TBEActiveCacheSync') === true;
  if (!isEnabled || bypassHtmlCacheRegex.test(window.location.search)) {
    return;
  }

  cancelPendingCacheSync();
  pendingSyncTimeout = setTimeout(() => {
    const scriptVer = document.querySelector('meta[name="scriptVer"]')?.getAttribute('content');
    if (scriptVer) {
      const message: { readonly type: SWSyncMessageType; readonly scriptVer: string } = {
        type: 'PRECACHE_LATEST_RELEASE_ASSETS_AFTER_DELAY',
        scriptVer,
      };
      navigator.serviceWorker.controller?.postMessage(message);
    }
    pendingSyncTimeout = undefined;
  }, syncDelayMs);
};
